import { connect } from "react-redux";

import SectionPage from "shared/components/roomBook/SectionPage";
import { getUnit, getUnitPath, findSection } from "shared/selectors/unit";

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state, props) => {
  const { i18n } = state;
  const { sectionId } = props.params;
  const unitPath = getUnitPath(props);
  const unit = getUnit(state);
  const section = findSection(state)(sectionId);
  const parentSection = findSection(state)(section.parentId);

  return {
    i18n,
    section,
    parentSection,
    unitPath,
    unit,
    isReady: true
  };
};

export default connect(mapStateToProps)(SectionPage);
